"use client";

import React from "react";
import { CircleAlert, Bell, CircleCheck, Flag, Menu, Search, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
const blockers = [{
  id: 1,
  title: "Sicherheits-Check",
  desc: "Kostenlose Erstbesichtigung für Ihre Bäume in Hamburg & Ahrensburg.",
  time: "Sofort"
}, {
  id: 2,
  title: "Baumschutz-Planung",
  desc: "Fachgerechte Baubegleitung für Ihr aktuelles Bauprojekt.",
  time: "Aktiv"
}, {
  id: 3,
  title: "Notfall-Service",
  desc: "Totholzentfernung und Sturmschaden-Beseitigung rund um die Uhr.",
  time: "24/7"
}];
const milestones = [{
  id: 1,
  title: "Baumhaus Projekt Nord",
  date: "Okt 15, 2023",
  status: "In Arbeit"
}, {
  id: 2,
  title: "Gebäudefreischnitt Villa",
  date: "Okt 22, 2023",
  status: "Geplant"
}, {
  id: 3,
  title: "Wurzelentfernung Park",
  date: "Nov 01, 2023",
  status: "Abgeschlossen"
}];
export default function Dashboard() {
  return;
}